import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import SurveySubmissionForm from './SurveySubmissionForm';
import { publicSurveySubmissionFormValidation } from '../../models/survey/SurveySubmissionValidation';

class PublicSurveySubmissionDetails extends React.Component {
  handleSubmit = data => this.props.onSubmit(this.props.surveyId, data);

  handleDeletedUploadedFile = (questionId, fileId) => this.props.onDeleteUploadedFile(this.props.surveyId, questionId, fileId);

  render() {
    const { surveyId, form, respondentProfile, approvals, tenantName, readonly, proposedLocations, initialLocation, unit, participantsVerification, identificationMethods } = this.props;

    return (
      <SurveySubmissionForm
        surveyId={surveyId}
        form={form}
        respondentProfile={respondentProfile}
        approvals={approvals}
        validate={values => publicSurveySubmissionFormValidation(values, form, participantsVerification)}
        onSubmit={this.handleSubmit}
        tenantName={tenantName}
        readonly={readonly}
        proposedLocations={proposedLocations}
        initialLocation={initialLocation}
        onDeleteUploadedFile={this.handleDeletedUploadedFile}
        unit={unit}
        participantsVerification={participantsVerification}
        identificationMethods={identificationMethods}
        actions={this.props.actions}
      />
    );
  }
}

PublicSurveySubmissionDetails.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  tenantName: PropTypes.string.isRequired,
  surveyId: PropTypes.string.isRequired,
  form: PropTypes.array.isRequired,
  respondentProfile: PropTypes.array.isRequired,
  approvals: PropTypes.object,
  readonly: PropTypes.bool,
  proposedLocations: PropTypes.object,
  initialLocation: PropTypes.object,
  onDeleteUploadedFile: PropTypes.func.isRequired,
  unit: PropTypes.object,
  participantsVerification: PropTypes.object.isRequired,
  identificationMethods: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

export default translate()(PublicSurveySubmissionDetails);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/PublicSurveySubmissionDetails.js